<template>
  <b-form-group
    label="Kiracı Kodu"
    label-for="tenant_code"
  >
    <validation-provider
      #default="{ errors }"
      name="Kiracı Kodu"
      rules="required"
    >
      <b-form-input
        id="tenant_code"
        v-model="dataItem.tenant_code"
        placeholder="Kiracı Kodu"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'TenantCode',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['tenants/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
